import { PrinterOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import moment from "moment";
import Loadercomponent from "../../../../Componets/Loader";
import toast from "react-hot-toast";
import { get_transfer } from "../../../../Controllers/Inventory/Transfer";
import { get_receive } from "../../../../Controllers/Inventory/Received";
import URL from "../../../../Main/url";

const ReceivedView = () => {
  let componentRef = useRef();

  let { id } = useParams();
  const [loader, setLoader] = useState(false);

  const [details, setDetails] = useState();

  const fetchData = async () => {
    setLoader(true);

    let data = {
      id: id,
    };

    let transfer = await get_receive(data);
    if (transfer?.status) {
      // console.log(transfer?.data, "transfer?.data");
      setDetails(transfer?.data);

      console.log(transfer?.data);
      // setCompanyName(transfer?.data?.branch?.name);
      setLoader(false);
    } else {
      toast?.error(transfer?.message);
      setLoader(false);
    }
  };

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
      @page {
        size: A4;
        margin: 6% 6% 16% 6%;
         @bottom-left {
          font-size: 12px;
          content: "\\A \\A \\A \\A Customer's Signature (Name/Designation/Co. Seal) \\A \\A \\A";
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          left: 6%;
        }
        @bottom-right {
          font-size: 12px;
          content: "\\A \\A \\A \\A For ${details?.branch?.name} \\A \\A " counter(page) " of " counter(pages);
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          right: 6%;
        }
      }
  
      @media print {
        .a4-invoice-footer {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          left: 6%;
        }
  
        .a4-invoice-footer-right {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          right: 6%;
        }
      }
    `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    fetchData();
    if (details?.branch?.name) {
      injectScopedStyles();
    }
  }, [details?.branch?.name]);

  return (
    <div className="p-4">
      {/* page */}
      <Loadercomponent loader={loader}>
        <div className="flex justify-center">
          <div className="w-[8.27in]  text-right py-4">
            <ReactToPrint
              trigger={() => (
                <div className="">
                  <PrinterOutlined className="text-2xl" />
                </div>
              )}
              content={() => componentRef}
            />
          </div>
        </div>
        <div className="px-24">
          <div className="" ref={(el) => (componentRef = el)}>
            <div>
              {/*letter header */}
              <div className="text-black-900 text-[0.65rem] text-center">
                <div className="text-center">
                  {details?.supplier?.image ? (
                    <div className="flex justify-center">
                      <div className="text-xl pb-2">
                        <img
                          className="w-[50px] h-[50px]"
                          src={`${URL}/uploads${details?.supplier?.image}`}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="text-medium text-xl">
                    {details?.supplier?.name}
                  </div>
                  <div className="text-medium">
                    {details?.supplier?.category}
                  </div>
                </div>
              </div>
              <div className="text-black-900 text-[0.65rem] text-center pt-4">
                <span>
                  Email&nbsp;:&nbsp;
                  {details?.supplier?.email
                    ? details?.supplier?.email + ", "
                    : ""}
                  &nbsp;
                </span>
                <span>
                  Phone&nbsp;:&nbsp;
                  {details?.supplier?.phone ? details?.supplier?.phone : ""}
                  &nbsp;
                </span>
                <div>
                  {details?.supplier?.area
                    ? details?.supplier?.area + ", "
                    : ""}
                  {details?.supplier?.city
                    ? details?.supplier?.city + ", "
                    : ""}
                  {details?.supplier?.country ? details?.supplier?.country : ""}
                </div>
                <div>
                  VATIN&nbsp;:&nbsp;
                  {details?.supplier?.tax ? details?.supplier?.tax : "N/A"}
                </div>
              </div>
              {/*letter header end */}
              {/* heading */}
              <hr className="my-4 border-t-black-900 border-black" />
              <div className="text-medium text-xl text-center">
                Received Order
              </div>
              <div className="text-[0.60rem] pb-6">
                <div className="flex justify-between">
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td className="">
                            {details?.branch?.name ? details?.branch?.name : ""}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {details?.branch?.phone
                              ? "Phone : " + details?.customer?.phone
                              : ""}
                            &nbsp;
                            {details?.branch?.email
                              ? ", Email : " + details?.customer?.email
                              : ""}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {details?.branch?.city
                              ? details?.branch?.city + ", "
                              : " "}
                            {details?.branch?.state}
                          </td>
                        </tr>
                        <tr>
                          <td>{details?.branch?.country}</td>
                        </tr>
                        <tr>
                          <td>
                            {details?.branch?.tax
                              ? "VATIN : " + details?.supplier?.tax
                              : ""}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td>Received No</td>
                          <td className="px-2">:</td>
                          <td className="text-right">
                            #RECEIVED-{details?.number}
                          </td>
                        </tr>
                        <tr>
                          <td>Date</td>
                          <td className="px-2">:</td>
                          <td className="text-right">
                            {moment?.(details?.date)?.format?.("DD-MM-YYYY")}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* table */}
              <div className="">
                <table className="w-full">
                  <thead className="bg-black">
                    <tr className="text-[0.60rem]">
                      <th className="font-normal  text-white  text-left py-2 pl-3">
                        <div className="text-[0.60rem]">S.NO</div>
                      </th>
                      <th className="font-normal text-white text-left p-2">
                        <div className="text-[0.60rem]">DESCRIPTION</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">UNIT</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">QTY</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">RET.PRICE</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">W.S&nbsp;PRICE</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">DISC</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">FOC</div>
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        <div className="text-[0.60rem]">VAT</div>
                      </th>
                      <th className="font-normal text-white text-right pr-2">
                        <div className="text-[0.60rem]">TOTAL</div>
                      </th>
                    </tr>
                  </thead>
                  {/* table body */}
                  <tbody className="text-sm">
                    {details?.details?.map((value, index) => {
                      return (
                        <tr className="uppercase border-b border-gray-300 ">
                          <td className="text-[0.60rem] leading-[0.75rem] align-top">
                            <div className="pl-3">{index + 1}</div>
                          </td>
                          <td className="text-left leading-[0.75rem] align-top">
                            <div className="text-[0.60rem] p-0 m-0 text-medium">
                              {value?.name}
                            </div>
                            <div className="text-gray-500 p-0 m-0 text-[0.60rem]">
                              #BATCH-{value?.description?.number}
                            </div>
                            <div className="text-gray-500 p-0 m-0  text-[0.60rem]">
                              {value?.expiry_date
                                ? `Expiry : ${moment?.(
                                    value?.expiry_date
                                  )?.format("DD-MM-YYYY")}`
                                : ""}
                            </div>
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.unit_name}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.quantity}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.description?.sale_price?.toFixed(3)}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.sale_price?.toFixed(3)}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            <div className="text-[0.60rem]">
                              {value?.discount_percentage}%
                            </div>
                            <div className="text-[0.60rem] text-gray-500 leading-[0.75rem] align-top">
                              {value?.discount_price?.toFixed?.(3)}
                            </div>
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.free ? value?.free : 0}
                          </td>
                          <td className="text-center leading-[0.75rem] align-top">
                            <div className="text-[0.60rem] ">{value?.tax}%</div>
                            <div className="text-[0.60rem] text-gray-500">
                              {value?.tax_amount?.toFixed(3)}
                            </div>
                          </td>
                          <td className="text-right text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.total?.toFixed(3)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  {/* table foot */}
                  <tfoot className="text-xs text-medium leading-[0.75rem]">
                    <tr>
                      <th colSpan={8}></th>
                      <th className="font-normal text-right p-[4px]">
                        Subtotal
                      </th>
                      <td className="font-normal text-right p-[4px]">
                        {details?.subtotal?.toFixed(3)}
                      </td>
                    </tr>
                    <tr>
                      <th colSpan={8}></th>
                      <th className="font-normal text-right p-[4px]">
                        VAT (5%)
                      </th>
                      <td className="font-normal text-right p-[4px]">
                        {details?.taxamount?.toFixed(3)}
                      </td>
                    </tr>
                    <tr>
                      <th colSpan={8}></th>
                      <th className="font-normal text-right p-[4px]">
                        Discount
                      </th>
                      <td className="font-normal text-right p-[4px]">
                        {details?.discount_type
                          ? details?.discount_value
                            ? `${details?.discount?.toFixed(3)} (-${
                                details?.discount_value
                              }%)`
                            : "0.000"
                          : details?.discount
                          ? `-${details?.discount?.toFixed(3)}`
                          : "0.000"}
                      </td>
                    </tr>
                    {details?.delivery ? (
                      <tr>
                        <th colSpan={8}></th>
                        <th className="font-normal text-right p-[4px]">
                          Delivery Charge
                        </th>
                        <td className="font-normal text-right p-[4px]">
                          +{details?.delivery?.toFixed(3)}
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    <tr>
                      <th colSpan={8}></th>
                      <th className="font-normal text-right text-white bg-black p-[4px]">
                        Total&nbsp;(OMR)
                      </th>
                      <td className="font-normal text-right text-white bg-black p-[4px]">
                        {details?.total?.toFixed(3)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
                {/* <div className="text-[0.60rem] text-right pt-4">
                  Total in words&nbsp;:&nbsp;
                  <CurrencyWord amount={details?.total?.toFixed(3)} />
                </div> */}
              </div>
              {/* note */}
              <div className="pt-4 text-sm">
                <div className=""></div>
                <div className="pt-4"></div>
              </div>
            </div>
          </div>
        </div>
      </Loadercomponent>
    </div>
  );
};

export default ReceivedView;
